/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import WindowEventsHandler from '../../services/WindowEventsHandler';

import ControlSection from './landing/ControlSection';
import HowItWorks from './landing/HowItWorks';
import AdviserInfo from './landing/AdviserInfo';
import VerifiedDetails from './landing/VerifiedDetails';

import AboutUs from './shared/AboutUs';
import AsFeaturedIn from './shared/AsFeaturedIn';

import * as Actions from '../../actions/actions';

/* Load hero banner images for all sizes */
require('url!../../../images/hero_banner_large.jpg');
require('url!../../../images/hero_banner_xsmall.jpg');

export class LandingPage extends Component {
    componentWillMount() {
        const query = this.props.location ? this.props.location.query : {};
        this.props.actions.reset(query);
        this.props.actions.initialiseUrlQueryData(query);
    }

    componentDidMount() {
        WindowEventsHandler.disableUnloadMessage();
    }

    /* eslint no-undef: 0 */
    scrollToForm() {
        if (!this.props.canSubmit) {
            const formAnchor = document.getElementById('form-anchor');

            $('html, body').animate({
                scrollTop: $(formAnchor).offset().top,
            }, 700);
        } else {
            browserHistory.push('contact');
        }
    }

    render() {
        return (
            <div className="landing-page push-down-30">
                <ControlSection scrollToForm={ this.scrollToForm.bind(this) }/>
                <HowItWorks/>
                <VerifiedDetails/>
                <AdviserInfo scrollToForm={ this.scrollToForm.bind(this) }/>
                <AsFeaturedIn/>
                <AboutUs/>
            </div>
        );
    }
}

LandingPage.propTypes = {
    canSubmit: React.PropTypes.bool,
    actions: React.PropTypes.object,
};

function mapStateToProps(state) {
    return {
        canSubmit: state.navigation.get('canSubmit'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);



// WEBPACK FOOTER //
// ./src/components/steps/LandingPage.jsx